import { Box } from '@mui/material'
import React from 'react'
import { avatarPropStyles } from '../../../../../../../core/styling/global'

export const Images = ({ viewdata }) => {
	const dsgimage = viewdata.data

	return (
		<Box width="100%" display="flex" flexDirection="column" alignItems="center" p="8px 40px 8px 40px" gap={3}>
			<Box width="100%" bgcolor="#F1F1F1" height={456} borderRadius={4}>
				<Box sx={avatarPropStyles(dsgimage.content.images.first_img, '100%', "100%", 4)}></Box>
			</Box>
			<Box width="100%" display="flex" alignItems="center" gap={2}>
				<Box width="100%" bgcolor="#F1F1F1" height={256} borderRadius={4}>
					<Box sx={avatarPropStyles(dsgimage.content.images.second_img, '100%', "100%", 4)}></Box>
				</Box>
				<Box width="100%" bgcolor="#F1F1F1" height={256} borderRadius={4}>
					<Box sx={avatarPropStyles(dsgimage.content.images.third_img, '100%', "100%", 4)}></Box>
				</Box>
			</Box>
			<Box width="100%" bgcolor="#F1F1F1" height={456} borderRadius={4}>
				<Box sx={avatarPropStyles(dsgimage.content.images.fourth_img, '100%', "100%", 4)}></Box>
			</Box>
			<Box width="100%" display="flex" alignItems="center" gap={2}>
				<Box width="100%" bgcolor="#F1F1F1" height={256} borderRadius={4}>
					<Box sx={avatarPropStyles(dsgimage.content.images.fifth_img, '100%', "100%", 4)}> </Box>
				</Box>
				<Box width="100%" bgcolor="#F1F1F1" height={256} borderRadius={4}>
					<Box sx={avatarPropStyles(dsgimage.content.images.sixth_img, '100%', "100%", 4)}></Box>
				</Box>
			</Box>
		</Box>
	)
}

